export default __webpack_public_path__ + "static/media/lds-logo_ja.8ceb57a1196400ae.svg";